export default __webpack_public_path__ + "bf294a216aedc4e70a6e8b8daf1f49e9.png";